import { defineComponent,ref } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import { saveAs } from 'file-saver';
import { Field, Form, ErrorMessage, useField, useForm } from 'vee-validate';
import dcmapbox from '../Shared/dcmapbox.vue';
import * as yup from 'yup';
import * as bootstrap from "bootstrap";
import { createPinia } from 'pinia';

class dcmapboxcoord {
    public latitude: number = 0;
    public longitude: number = 0;

};

enum typeqrcode {
  notdefined=-1,  text = 0, url = 1, bookmark = 2, calendar = 3, contact = 4, geolocation = 5, mail = 6, mms = 7, phonenumber = 8, skype = 9, sms = 10, whatsapp = 11, bitcoin = 12,wifi=13
};

 enum AuthenticationWIFI {
    WEP = 0,
    WPA = 1,
    nopass = 2
};

let g_emailinvalide: string = "";
let g_url_invalide: string = "";
let g_numphone_invalide: string = "";

const mixin = defineComponent({
    components: { Field, Form, ErrorMessage, dcmapbox },
    data() {
        const regexnumberphone: RegExp = new RegExp("^[0-9]+$");
        const schema = yup.object({
            gen_mail_mailReceiver: yup.string().required("champ requis").email(g_emailinvalide),
            gen_url_url: yup.string().url(g_url_invalide),
            gen_bookmark_url: yup.string().url(g_url_invalide),
            gen_mms_number: yup.string().matches(regexnumberphone,g_numphone_invalide),
            gen_sms_number: yup.string().matches(regexnumberphone, g_numphone_invalide),
            gen_phonenumber_number: yup.string().matches(regexnumberphone, g_numphone_invalide),
        });
        // Create a form context with the validation schema
        useForm({
            validationSchema: schema,
        });
        const { value: gen_mail_mailReceiver, errorMessage: gen_mail_mailReceiver_err } = useField(
            "gen_mail_mailReceiver"
        );
        const { value: gen_url_url, errorMessage: gen_url_url_err } = useField(
            "gen_url_url"
        );
        const { value: gen_bookmark_url, errorMessage: gen_bookmark_url_err } = useField(
            "gen_bookmark_url"
        );
        const { value: gen_mms_number, errorMessage: gen_mms_number_err } = useField(
            "gen_mms_number"
        );
        const { value: gen_sms_number, errorMessage: gen_sms_number_err } = useField(
            "gen_sms_number"
        );
        const { value: gen_phonenumber_number, errorMessage: gen_phonenumber_number_err } = useField(
            "gen_phonenumber_number"
        );
        
        return {
            typecodeurl: typeqrcode.notdefined,
            sizeqrcode:580,
            qrcodeurl: "",
            gen_url_url,
            gen_url_url_err,
            gen_bookmark_url,
            gen_bookmark_url_err,
            gen_bookmark_title: "",
            gen_calendar_subject: "",
            gen_calendar_description: "",
            gen_calendar_location: "",
            gen_calendar_start: "",
            gen_calendar_end: "",
            gen_calendar_alldayevent: true,
            gen_contact_outputType: null,
            gen_contact_firstname: "",
            gen_contact_lastname: "",
            gen_contact_nickname: "",
            gen_contact_phone: "",
            gen_contact_mobilePhone: "",
            gen_contact_workPhone: "",
            gen_contact_email: "",
            gen_contact_birthday: Date,
            gen_contact_website: "",
            gen_contact_street: "",
            gen_contact_houseNumber: "",
            gen_contact_city: "",
            gen_contact_zipCode: "",
            gen_contact_country: "",
            gen_contact_note: "",
            gen_contact_stateRegion: "",
            gen_contact_addressOrder: null,
            gen_contact_org: "",
            gen_contact_orgTitle: "",
            gen_geolocation_latitude: 0,
            gen_geolocation_longitude: 0,
            gen_mail_mailReceiver,
            gen_mail_mailReceiver_err,
            gen_mail_subject: "",
            gen_mail_message: "",
            gen_mms_number,
            gen_mms_number_err,
            gen_mms_subject: "",
            gen_phonenumber_number,
            gen_phonenumber_number_err,
            gen_skype_skypeusername: "",
            gen_sms_number,
            gen_sms_number_err,
            gen_sms_subject: "",
            gen_whatsapp_number: "",
            gen_whatsapp_message: "",
            gen_wifi_ssid: "",
            gen_wifi_password: "",
            gen_wifi_authentication: AuthenticationWIFI.nopass,
            gen_wifi_hiddenssid: false,
            gen_bitcoin_address: "",
            gen_bitcoin_amount:null as number|null,
            gen_text_text:""
        };
    },
   
     mounted() {
    },
    methods: {
        isTouchDevice() {
            return 'ontouchstart' in window || (window as any)['DocumentTouch'] && document instanceof (window as any)['DocumentTouch'];
        },
        ReloadTooltips() {
            $("[data-bs-toggle='tooltip']").tooltip('hide');
            this.$nextTick(function () {
                if (!this.isTouchDevice()) {
                    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl)
                    });
                }
                else
                    $('[data-bs-toggle="tooltip"]').removeAttr("title");
            });
        },
        ScrollStep(step: number) {
            this.$nextTick(function () {
                let elt = null;
                elt = document.getElementById('qrcode_step' + step);
                if (elt != null)
                    window.scrollTo(0, elt.offsetTop - 90);
            });
        },
        SetCoordonnees(coord: dcmapboxcoord) {
            this.gen_geolocation_latitude = coord.latitude;
            this.gen_geolocation_longitude = coord.longitude;
        },
        SetMyLocalisation() {
            let self = this;
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position) => {
                    self.gen_geolocation_latitude = position.coords.latitude;
                    self.gen_geolocation_longitude = position.coords.longitude;
                });
            }
        },
        DownloadQRCode() {
            saveAs(this.qrcodeurl,"qrcode.png");
        },
        ChangerTypeQrCode(typecode: typeqrcode) {
            this.typecodeurl = typecode;
            this.ScrollStep(2);
        },
        CreateQRCode() {
            if (this.typecodeurl == typeqrcode.text)
                this.CreateQRCodeText();
            else if (this.typecodeurl == typeqrcode.url)
                this.CreateQRCodeUrl();
            else if (this.typecodeurl == typeqrcode.bookmark)
                this.CreateQRCodeBookmark();
            else if (this.typecodeurl == typeqrcode.calendar)
                this.CreateQRCodeCalendarEvent();
            else if (this.typecodeurl == typeqrcode.contact)
                this.CreateQRCodeContactData();
            else if (this.typecodeurl == typeqrcode.geolocation)
                this.CreateQRCodeGeolocation();
            else if (this.typecodeurl == typeqrcode.mail)
                this.CreateQRCodeMail();
            else if (this.typecodeurl == typeqrcode.mms)
                this.CreateQRCodeMMS();
            else if (this.typecodeurl == typeqrcode.phonenumber)
                this.CreateQRCodePhoneNumber();
            else if (this.typecodeurl == typeqrcode.skype)
                this.CreateQRCodeSkypeCall();
            else if (this.typecodeurl == typeqrcode.sms)
                this.CreateQRCodeSMS();
            else if (this.typecodeurl == typeqrcode.whatsapp)
                this.CreateQRCodeWhatsAppMessage();
            else if (this.typecodeurl == typeqrcode.bitcoin)
                this.CreateQRCodeBitcoinAddress();
            else if (this.typecodeurl == typeqrcode.wifi)
                this.CreateQRCodeWiFi();
            //this.ScrollStep(3);
            this.ReloadTooltips();
            return this.qrcodeurl;
        },
        CreateQRCodeUrl() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeUrl?url=" + this.gen_url_url;
        },
        CreateQRCodeBookmark() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeBookmark?url=" + this.gen_bookmark_url + "&title=" + this.gen_bookmark_title;
        },

        CreateQRCodeCalendarEvent() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeCalendarEvent?subject=" + this.gen_calendar_subject + "&description=" + this.gen_calendar_description + "&location=" + this.gen_calendar_location + "&start=" + this.gen_calendar_start + "&end=" + this.gen_calendar_end + "&alldayevent=" + this.gen_calendar_alldayevent;
        },

        CreateQRCodeContactData() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeContactData?outputType=" + this.gen_contact_outputType + "&firstname=" + this.gen_contact_firstname + "&lastname=" + this.gen_contact_lastname + "&nickname=" + this.gen_contact_nickname + "&phone=" + this.gen_contact_phone + "&mobilePhone=" + this.gen_contact_mobilePhone + "&workPhone=" + this.gen_contact_workPhone + "&email=" + this.gen_contact_email + "&birthday=" + this.gen_contact_birthday + "&website=" + this.gen_contact_website + "&street=" + this.gen_contact_street + "&houseNumber=" + this.gen_contact_houseNumber + "&city=" + this.gen_contact_city + "&zipCode=" + this.gen_contact_zipCode + "&country=" + this.gen_contact_country + "&note=" + this.gen_contact_note + "&stateRegion=" + this.gen_contact_stateRegion + "&addressOrder=" + this.gen_contact_addressOrder + "&org=" + this.gen_contact_org + "&orgTitle=" + this.gen_contact_orgTitle;
        },

        CreateQRCodeGeolocation() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeGeolocation?latitude=" + this.gen_geolocation_latitude + "&longitude=" + this.gen_geolocation_longitude;
        },

        CreateQRCodeMail() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeMail?mailReceiver=" + this.gen_mail_mailReceiver + "&subject=" + this.gen_mail_subject + "&message=" + this.gen_mail_message;
        },

        CreateQRCodeMMS() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeMMS?number=" + this.gen_mms_number + "&subject=" + this.gen_mms_subject;
        },

        CreateQRCodePhoneNumber() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodePhoneNumber?number=" + this.gen_phonenumber_number;
        },

        CreateQRCodeSkypeCall() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeSkypeCall?skypeusername=" + this.gen_skype_skypeusername;
        },

        CreateQRCodeSMS() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeSMS?number=" + this.gen_sms_number + "&subject=" + this.gen_sms_subject;
        },

        CreateQRCodeWhatsAppMessage() {
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeWhatsAppMessage?number=" + this.gen_whatsapp_number + "&message=" + this.gen_whatsapp_message;
        },

        CreateQRCodeWiFi()
{
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeWiFi?ssid=" + this.gen_wifi_ssid + "&password=" + this.gen_wifi_password + "&authentication=" + this.gen_wifi_authentication + "&hiddenssid=" + this.gen_wifi_hiddenssid;
},

        CreateQRCodeBitcoinAddress()
{
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeBitcoinAddress?address=" + this.gen_bitcoin_address + "&amount=" + this.gen_bitcoin_amount;
},

        CreateQRCodeText()
{
            this.qrcodeurl = "/api/v1/QRCode/CreateQRCodeText?text=" + this.gen_text_text;
}
    }
});


export class QRCodeComponent {

    public Init(emailinvalide: string, url_invalide: string, numphone_invalide: string)
    {
        g_emailinvalide = emailinvalide;
        g_url_invalide = url_invalide;
        g_numphone_invalide = numphone_invalide;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).QRCodeComponent = function () { return new QRCodeComponent(); };